/* eslint-disable react/require-default-props */
import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Link as NuiLink } from '@theneatcompany/nui'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'
import NextLink from 'next/link'

const Link = forwardRef(({
  children,
  className,
  messageProps = {},
  messageId = messageProps.id,
  size,
  variant,
  round = !!variant && variant !== 'default',
  bold = false,
  to,
  onClick,
  ...rest
}, ref) => (
  <NextLink href={to} {...rest} legacyBehavior>
    <NuiLink
      ref={ref}
      className={cx(className, bold && 'text-bold', size === 'xlTall' && 'nui-button--xlTall')}
      onClick={onClick}
      round={round}
      size={size === 'xlTall' ? 'xlarge' : size}
      to={to}
      variant={variant}
      {...rest}
    >
      {messageId ? <FormattedMessage {...messageProps} id={messageId} /> : children}
    </NuiLink>
  </NextLink>
))

Link.propTypes = {
  bold: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  messageId: PropTypes.string,
  messageProps: PropTypes.shape({ id: PropTypes.string }),
  onClick: PropTypes.func,
  round: PropTypes.bool,
  size: PropTypes.oneOf(['tiny', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'xlTall']),
  to: PropTypes.string.isRequired,
  variant: PropTypes.string,
}

export default Link
